'use client';
/**
 * https://javascript.plainenglish.io/the-right-way-to-detect-mobile-breakpoints-in-nextjs-301ccb1976bd
 */
import { useContext, createContext } from 'react';
import { useWindowSize } from './use-window-size';

export const IsSsrMobileContext = createContext(false);

// https://tailwindcss.com/docs/responsive-design
export const BREAKPOINT_MD = 768;
export const BREAKPOINT_LG = 1024;
export const BREAKPOINT_XL = 1280;

export function useIsMobile() {
  const isSsrMobile = useContext(IsSsrMobileContext);
  const { width: windowWidth } = useWindowSize();
  const isBrowserMobile = Boolean(windowWidth) && windowWidth < BREAKPOINT_MD;

  return isSsrMobile || isBrowserMobile;
}
